import { render } from "./BlogEpr.vue?vue&type=template&id=1b315c94"
import script from "./BlogEpr.vue?vue&type=script&lang=js"
export * from "./BlogEpr.vue?vue&type=script&lang=js"

import "./BlogEpr.vue?vue&type=style&index=0&id=1b315c94&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__